import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Guides from '../views/Guides.vue'
import Primes from '../views/Primes.vue'
import Ventes from '../views/Ventes.vue'
import User from '../views/Users.vue'
import Agenecys from '../views/Agenecys.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/guides',
    name: 'Guides',
    component: Guides
  },
  {
    path: '/agence',
    name: 'agence',
    component: Agenecys
  },
  {
    path: '/primes',
    name: 'Primes',
    component: Primes
  },
  {
    path: '/ventes',
    name: 'Ventes',
    component: Ventes
  },
  {
    path: '/user',
    name: 'user',
    component: User
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
